/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_NeverInputs */

const he_common_never = /** @type {(inputs: Common_NeverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`אף פעם`)
};

const en_common_never = /** @type {(inputs: Common_NeverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Never`)
};

/**
* | output |
* | --- |
* | "Never" |
*
* @param {Common_NeverInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const common_never = /** @type {((inputs?: Common_NeverInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_NeverInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_common_never(inputs)
	return en_common_never(inputs)
});